import React from 'react';

function RightArrow() {
  return (
    <svg
      width="25"
      height="43"
      viewBox="0 0 28 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.682379 1.4917L26.5977 22.8995L0.682379 44.5"
        stroke="black"
        strokeWidth="1.32333"
      />
    </svg>
  );
}

export default RightArrow;
